import { z } from "zod";
import { CodeSchema } from "./Codes";

export const CheckingAccountSchema = z.object({
  checkingAccountId: z.string(),
  description: z.string(),
  bankName: z.string(),
  bankABANumber: z.string(),
  accountNumber: z.string(),
  nextCheckNumber: z.number().nullable(),
  active: z.boolean(),
  locked: z.boolean(),
  lockedBy: z.string(),
  bankNumber: z.string(),
  escrowNumber: z.string(),
  userGroup: CodeSchema,
});

export const CheckingAccountListSchema = z.array(CheckingAccountSchema);

export type CheckingAccount = z.infer<typeof CheckingAccountSchema>;
